<template>
<div class="base">
  <Header />
    <div style="margin:2rem 3rem;" class="comic"><span style="font-size:14pt;font-weight:bold">Hi!</span><br />Attempt the below worksheet in your classwork notebook<br />You can send a chat message with "talk to teacher" in case of any doubts or issues<br />Good Luck! ✨</div>
    <img style="float:right; margin-right:3rem; border: solid 1px;margin-bottom:2rem;" src="../assets/Worksheet2-1.png" width="80%" />

</div>
</template>

<script>
import Header from '@/components/Header';
export default {
  components: {
    Header,
  },
}
</script>

<style>
.comic {
  font-family:-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif
}
.flex {

  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>